<div [formGroup]="form()" class="flex flex-col gap-4">
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
    <div class="flex flex-col gap-1">
      <p-floatlabel class="w-full" variant="on">
        <p-inputNumber [inputId]="idPrefix() + '-perTx'" formControlName="maxAmountPerTransaction" mode="currency" currency="MXN"
          locale="es-MX" inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0"
          [invalid]="invalid('maxAmountPerTransaction')" fluid />
        <label [for]="idPrefix() + '-perTx'">Máximo por cobro *</label>
      </p-floatlabel>
    </div>
    <div class="flex flex-col gap-1">
      <p-floatlabel class="w-full" variant="on">
        <p-inputNumber [inputId]="idPrefix() + '-month'" formControlName="maxAmountPerMonth" mode="currency" currency="MXN"
          locale="es-MX" inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0"
          [invalid]="invalid('maxAmountPerMonth')" fluid />
        <label [for]="idPrefix() + '-month'">Máximo por mes *</label>
      </p-floatlabel>
      <small class="text-slate-500">Mes calendario, hora del centro de México</small>
    </div>
  </div>

  <details class="rounded-lg border border-slate-200 bg-slate-50/60 px-3 py-2 group">
    <summary class="cursor-pointer text-sm font-medium text-slate-700 select-none">Más límites (opcionales)</summary>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-3">
      <p-floatlabel class="w-full" variant="on">
        <p-inputNumber [inputId]="idPrefix() + '-min'" formControlName="minAmountPerTransaction" mode="currency" currency="MXN"
          locale="es-MX" inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" fluid />
        <label [for]="idPrefix() + '-min'">Mínimo por cobro</label>
      </p-floatlabel>
      <p-floatlabel class="w-full" variant="on">
        <p-inputNumber [inputId]="idPrefix() + '-day'" formControlName="maxAmountPerDay" mode="currency" currency="MXN"
          locale="es-MX" inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" fluid />
        <label [for]="idPrefix() + '-day'">Máximo por día</label>
      </p-floatlabel>
      <p-floatlabel class="w-full" variant="on">
        <p-inputNumber [inputId]="idPrefix() + '-total'" formControlName="maxTotalAmount" mode="currency" currency="MXN"
          locale="es-MX" inputStyleClass="text-right" [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" fluid />
        <label [for]="idPrefix() + '-total'">Máximo acumulado</label>
      </p-floatlabel>
      <p-floatlabel class="w-full" variant="on">
        <p-inputNumber [inputId]="idPrefix() + '-interval'" formControlName="minIntervalMinutes" [min]="1" [useGrouping]="false"
          inputStyleClass="text-right" suffix=" min" fluid />
        <label [for]="idPrefix() + '-interval'">Tiempo mínimo entre cobros</label>
      </p-floatlabel>
      <p-floatlabel class="w-full" variant="on">
        <p-inputNumber [inputId]="idPrefix() + '-txDay'" formControlName="maxTransactionsPerDay" [min]="1" [useGrouping]="false"
          inputStyleClass="text-right" fluid />
        <label [for]="idPrefix() + '-txDay'">Cobros por día</label>
      </p-floatlabel>
      <p-floatlabel class="w-full" variant="on">
        <p-inputNumber [inputId]="idPrefix() + '-txMonth'" formControlName="maxTransactionsPerMonth" [min]="1" [useGrouping]="false"
          inputStyleClass="text-right" fluid />
        <label [for]="idPrefix() + '-txMonth'">Cobros por mes</label>
      </p-floatlabel>
      <p-floatlabel class="w-full" variant="on">
        <p-inputNumber [inputId]="idPrefix() + '-txTotal'" formControlName="maxTotalTransactions" [min]="1" [useGrouping]="false"
          inputStyleClass="text-right" fluid />
        <label [for]="idPrefix() + '-txTotal'">Cobros en total</label>
      </p-floatlabel>
      <div class="flex flex-col gap-1">
        <p-floatlabel class="w-full" variant="on">
          <p-inputNumber [inputId]="idPrefix() + '-declines'" formControlName="maxConsecutiveDeclines" [min]="1" [useGrouping]="false"
            inputStyleClass="text-right" fluid />
          <label [for]="idPrefix() + '-declines'">Declinaciones seguidas</label>
        </p-floatlabel>
        <small class="text-slate-500">Al alcanzarlas, el mandato se suspende</small>
      </div>
    </div>
  </details>

  @for (message of groupErrors(); track message) {
    <p class="text-sm text-red-600 m-0">{{ message }}</p>
  }
</div>
